module.exports = {
  // APILOCALURL: "http://localhost:5126/api/",
  // APISERVERURL: "https://b2cclienttravel.azurewebsites.net/api/",
  // APIACTIVEURL: "http://localhost:5126/api/",
  // DEFAULTCOMPANYID: "D19EB72E-9995-4380-8E23-6A6E5316E035", //plan_RbWWOeO4p5Mv0t
  DEFAULTCURRENCY: "INR",
  LOGIN: "auth/login",
  REGISTER: "auth/register",
  LOGOUT: "auth/logout",
  REFRESH: "auth/refresh",
  SENDRESETLINK: "auth/sendresetlink",
  RESETPASSWORD: "auth/resetpassword",
  SENDCONFIRMATIONLINK: "auth/sendconfirmationlink",
  REGISTERCOMPANY: "auth/registercompany",


  CREATECOMPANYWALLET: "companywallet",
  GETTOPUPHISTORYBYCOMPANYID: "companywallet/getbycompany",

  GETAllBANKACCOUNTS: "companybankaccount/getallbycompany",
  GETBANKSBYCOMPANYID: "companybankaccount/getbycompany",
  CREATECOMPANYBANK: "companybankaccount",
  UPDATECOMPANYBANK: "companybankaccount",
  DELETECOMPANYBANK: "companybankaccount",

  SAASREGISTER: "company/saasregister",
  SAASACTIVATE: "company/UpdateTaxInformation",
  VERIFYCOMPANY: "auth/verifyemail",
  SUPPLIERREGISTER: "company/supplierregister",
  SUPPLIERACTIVATE: "company/UpdateSupplierInformation",

  CREATESUBSCRIPTION: "Subscription/create",
  CONFIRMSUBSCRIPTION: "Subscription/confirm",
  GETSUBSCRIPTIONBYCOMPANY: "Subscription/company",


  GETCREDITHISTORY: "credithistory/company",
  GETPRICINGPLANS: "connects/pricing",
  RECHARGECONNECTS: "connects/recharge",

  GETUSERSBYCOMPANY: "user/getbycompany",
  GETUSERSBYBRANCH: "user/getbybranch",
  GETSTAFFBYCOMPANY: "User/getstaffbycompany",
  CREATEUSER: "user",
  UPDATEUSER: "user",
  DELETEUSER: "user",
  GETUSERPROFILE: "user/getprofile",
  CHANGEPASSWORD: "user/changepassword",

  GETALLCOMPANIES: "company/getall",
  GETCOMPANIES: "company/get",
  GETCOMPANYBYID: "company/getbyid",
  GETCOMPANYBYUSER: "company/getbyuser",
  GETCOMPANYAGENTS: "company/agents",
  GETALLAGENTBYCOMPANY: "company/getallagents",
  CREATECOMPANYBYSUPERADMIN: "company/createcompanybysuperadmin",
  UPDATECOMPANY: "company",
  UPDATECOMPANYBYSUPERADMIN: "company/updatebysuperadmin",
  DELETECOMPANY: "company",
  CREATEB2BCOMPANY: "company/b2bcreate",
  UPDATEB2BCOMPANY: "company/updateagent",
  UPDATECOMPANYSTATUS: "company/updatestatus",
  UPDATEWHATSAPPNUMBER: "company/updatewhatsappnumber",
  UPDATECOMPANYCHATBOT: "company/updatechatbot",
  CONNECTWHATSSDK: "whatsapp/start-signup",
  WHATSAPPFINISH: "whatsapp/finish-signup",
  WHATSAPPVERIFY: "whatsapp/verify-code",

  GETALLBRANCHES: "branch/getall",
  GETBRANCHES: "branch/get",
  GETBRANCHBYID: "branch/getbyid",
  GETBRANCHBYUSER: "branch/getbyuser",
  GETBRANCHBYCOMPANY: "branch/getbycompany",
  CREATEBRANCH: "branch",
  UPDATEBRANCH: "branch",
  DELETEBRANCH: "branch",

  GETCOMPANYMENUBYCOMPANY: "companymenu/getbycompany",
  CREATECOMPANYMENU: "companymenu",
  UPDATECOMPANYMENU: "companymenu",
  DELETECOMPANYMENU: "companymenu",

  GETCURRENCY: "currency",
  CREATECURRENCY: "currency",
  UPDATECURRENCY: "currency",
  DELETECURRENCY: "currency",


  GETPAYMENTGATEWAYBYCOMPANY: "paymentgateway/getbycompany",
  CREATEPAYMENTGATEWAY: "paymentgateway",
  UPDATEPAYMENTGATEWAY: "paymentgateway",
  DELETEPAYMENTGATEWAY: "paymentgateway",
  MAKEPAYMENT: "payment/process",

  GETPROMOCODEBYCOMPANY: "promocode/getbycompany",
  CREATEPROMOCODE: "promocode",
  UPDATEPROMOCODE: "promocode",
  DELETEPROMOCODE: "promocode",

  SEARCHFLIGHTS: "flight/search",
  REVIEWHFLIGHT: "flight/review",
  BOOKFLIGHT: "flight/book",
  B2EBOOKFLIGHT: "flight/b2ebook",
  GETUSERFLIGHTBOOKINGS: "flight/getbyuser",
  GETCOMPANYFLIGHTBOOKINGS: "flight/getbycompany",
  GETPARENTCOMPANYFLIGHTBOOKINGS: "flight/getbyparentcompany",
  GETFLIGHTBOOKINGDETAILS: "flight/getbyid",
  CONFIRMHOLDFLIGHTBOOKING: "flight/Confirm-Hold",
  UPDATEFLIGHTBOOKING: "flight/updatebooking",
  FLIGHTSUPPLIERREPORT: "flight/getsupplierreport",

  SEARCHHOTEL: "hotel/search",
  GETHOTELROOMS: "hotel/rooms",
  HOTELREVIEW: "hotel/review",
  BOOKHOTEL: "hotel/book",
  GETUSERHOTELBOOKINGS: "hotel/getbyuser",
  GETHOTELBOOKINGDETAILS: "hotel/getbyid",
  GETCOMPANYHOTELBOOKINGS: "hotel/getbycompany",
  GETPARENTCOMPANYHOTELBOOKINGS: "hotel/getbyparentcompany",
  GETGSTREPORT: "hotel/gstreport",
  GETHOTELREPORTFORB2E: "hotel/getbycompanyreportb2e",


  GETALLPACKAGES: "package/getall",
  GETPACKAGE: "package/get",
  GETPACKAGEBYID: "package/getbyid",
  GETPACKAGEBYCOMAPANYID: "package/getbycompany",
  GETPACKAGEDETAILS: "package/getpackagedetails",
  GETPACKAGESBYDESTINATION: "package/getbydestination",
  GETPACKAGESBYSEARCH: "package/getbysearch",
  UPDATETOGGLE: "package/togglewebsite",
  GETWEBSITEPACKAGES: "package/getwebsitepackagesbycompany",


  SIGHTSEEINGPRODUCTS: "sightseeing/getproducts",
  SIGHTSEEINGPRODUCT: "sightseeing/getproduct",
  SIGHTSEEINGBOOK: "sightseeing/book",
  GETSIGHTSEEINGBOOKINGDETAILS: "sightseeing/getbyid",
  GETPARENTCOMPANYSIGHTSEEINGBOOKINGS: "sightseeing/getbyparentcompany",
  SIGHTSEEINGCHECKAVAILABILITY: "sightseeing/checkavailability",
  GETSIGHTSEEINGFORADMIN: "sightseeing/admin",
  UPDATESIGHTSEEINGBYADMIN: "sightSeeing/updatebooking",


  GETALLPACKAGEENQUIRY: "packageenquiry/getall",
  GETPACKAGEENQUIRYBYID: "packageenquiry/getbyid",
  GETPACKAGEENQUIRYBYCOMPANYID: "packageenquiry/getbycompany",
  CREATEPACKAGEENQUIRY: "packageenquiry",
  UPDATEPACKAGEENQUIRY: "packageenquiry",
  DELETEPACKAGEENQUIRY: "packageenquiry",
  GETENQUIRYBYTYPE: "packageenquiry/getbytypeandcompany",

  GETLANDINGBYCOMPANY: "landingpage/getbyCompany",
  UPDATELANDINGPAGE: "landingpage",

  CREATEBOOKINGREQUEST: "groupbooking",
  GETAGENTBOOKING: "groupbooking/getbyagent",
  GETADMINBOOKING: "groupbooking/getbyadmin",
  DELETEBOOKINGREQUEST: "groupbooking",
  UPDATEBOOKINGREQUEST: "groupbooking/updatestatus",
  GETBOOKINGBYID: "groupbooking",

  GETDASHBOARD: "dashboard",

  GETALLPROMOTIONS: "promotion/getall",
  GETPROMOTIONS: "promotion/get",
  GETPROMOTIONBYID: "promotion/getbyid",
  GETPROMOTIONBYUSER: "promotion/getbyuserid",

  GETVISAREQUESTS: "visarequest/get",
  GETVISAREQUESTBYID: "visarequest/getbyid",
  GETVISAREQUESTREPORTBYCOMPANY: "visarequest/getvisareportbycompany",
  GETVISASUPPLIERREPORT: "visarequest/getvisasupplierreport",
  SENDVISATOSUPPLIER: "visarequest/send",
  CREATEVISAREQUEST: "visarequest",
  UPDATEVISAREQUEST: "visaRequest",
  UPDATEVISASTATUS: "visaRequest/UpdateStatus",
  UPDATEVISAMARKUP: "visaRequest/updatepricing",
  DELETEVISAREQUEST: "visaRequest",

  GETVISAAPPLICANTSBYREQUEST: "visaapplicant",
  GETVISAREQUESTSBYSUPPLIER: "visaapplicant/supplier",
  CREATEVISAAPPLICANT: "visaapplicant",
  UPDATEVISAAPPLICANT: "visaapplicant",
  DELETEVISAAPPLICANT: "visaapplicant",
  UPDATEAPPLICANTSTATUSANDFILE: "visaApplicant/updateapplicantstatus",
  UPDATEVISAREQUESTPRICING: "visaapplicant/updatepricing",

  DELETEVISAAPPLICANTDOCUMENT: "visaapplicant/delete-document",

  // Other endpoints
  GETALLSUPPLIERVISAPRICES: "suppliervisaprice/getall",
  GETSUPPLIERVISAPRICESBYSUPPLIERID: "suppliervisaprice/getbysupplier",
  GETSUPPLIERVISAPRICESBYVISAID: "suppliervisaprice/getbyvisa",
  GETBESTPRICEBYVISAID: "SupplierVisaPrice/getbestprice",
  CREATESUPPLIERVISAPRICE: "suppliervisaprice",
  UPDATESUPPLIERVISAPRICE: "suppliervisaprice",
  DELETESUPPLIERVISAPRICE: "suppliervisaprice",


  SEARCHBUSES: "bus/search",
  GETBUSSEATS: "bus/seats",
  GETBUSBOOKINGBYID: "bus/getbooking",
  BOOKBUSSEATS: "bus/bookbusticket", // This will be for direct booking
  BLOCKBUSSEATS: "bus/blockbusticket", // New: Only block seats
  CONFIRMBLOCKEDBOOKING: "bus/blockandbookbusticket", // New: Book blocked seats
  GETBUSBOOKINGS: "bus/getbookings",
  GETCOMPANYBUSBOOKINGS: "/bus/getcompanybookings",
  GETPARENTCOMPANYBUSBOOKINGS: "bus/getbyparentcompany",
  B2EBUSBOOK: "bus/b2ebookbusticket",

  FLIGHTSUPPLIERREPORT: "flight/getsupplierreport",
  GETFLGIHTREPORTBYCOMPANYID: "flight/getbycompanyreport",
  GETFLIGHTREPORTFORB2E: "flight/getbycompanyreportb2e",
  GETHOLIDAYBYID: "holiday",
  GETHOLIDAYSBYCOMPANYID: "holiday/getbycompany",

  GETALLFAQCATEGORY: "faqcategory/getall",

  GETALLFAQ: "faq/getall",
  

  CREATEOUTING: "corporate/outings",
  GETOUINGSBYCOMPANYID: "corporate/outings/history",
  GETOUTINGCHATBYID: "corporate/outings/chat",
  CREATECHATMESSAGE: "corporate/outings/message",

  GETALLGROUPTOURS: "corporate/grouptours/history",
  CREATEGROUPTOUR: "corporate/grouptours/create",
  GETGROUPTOURCHATBYID: "corporate/grouptours/chat",
  SENDGROUPTOURMESSAGE: "corporate/grouptours/message", 
  ADDTRAVELLER: "corporate/grouptours/add-traveller",

  GETSALEINVOICEBYID: "mongoaccouting/detailed-sales-invoice",

  GETALLVISAAPPOINTMENTS: "VisaAppointment/GetAll",
   

  GETALLACCOUNTTYPES: "accounttype/getall",
  GETACCOUNTTYPES: "accounttype/get",
  GETACCOUNTTYPEBYID: "accounttype/getbyid",
  CREATEACCOUNTTYPE: "accounttype",
  UPDATEACCOUNTTYPE: "accounttype",
  DELETEACCOUNTTYPE: "accounttype",

  GETALLACCOUNTS: "account/getall",
  GETALLACCOUNTBYINDUSTRY: "account/getaccountbyindustry",
  GETACCOUNTS: "account/get",
  GETACCOUNTBYID: "account/getbyid",
  CREATEACCOUNT: "account",
  UPDATEACCOUNT: "account",
  DELETEACCOUNT: "account",

  GETALLITEMSBYUSER: "item/getallitemsbyuser",
  GETITEMSBYUSER: "item/getitemsbyuser",
  GETITEMSBYACCOUNTTYPE: "item/getitemsbyaccounttype",
  CREATEITEM: "item",
  UPDATEITEM: "item",
  DELETEITEM: "item",

  GETACCOUNTITEMSBYUSER: "accountitem/getaccountitemsbyuser",
  CREATEACCOUNTITEM: "accountitem",
  UPDATEACCOUNTITEM: "accountitem",
  DELETEACCOUNTITEM: "accountitem",

  GETINVOICEBYID: "invoice/getbyid",
  GETINVOICEBYUSER: "invoice/getbyuser",
  CREATEINVOICE: "invoice",
  UPDATEINVOICE: "invoice",
  DELETEINVOICE: "invoice",
  INVOICESUMMARY: "invoice/getinvoicesummary",
  GETSERIALNUMBER: "invoice/serialnumber",
  GENERATEINVOICENUMBER: "invoice/generateinvoicenumber",

  GETALLTAXRATESBYUSER: "taxrate/getalltaxratesbyUser",
  GETTAXRATEBYUSER: "taxrate/gettaxratesbyUser",
  CREATETAXRATE: "taxrate",
  UPDATETAXRATE: "taxrate",
  DELETETAXRATE: "taxrate",

  GETCHEQUEBYUSER: "cheque/getbyuser",
  CREATECHEQUE: "cheque",
  UPDATECHEQUE: "cheque",
  DELETECHEQUE: "cheque",
  CHEQUESUMMARY: "cheque/getchequecount",

  SEARCHINVOICENUMBER: "invoicereports/invoicenumbersearch",
  SALESREPORT: "invoicereports/sales-by-item",
  PURCHASESREPORT: "invoicereports/purchases-by-item",
  INVOICEREPORT: "invoicereports/invoices",
  EXPENSEREPORT: "invoicereports/expense-invoices",
  PROFITLOSSREPORT: "invoicereports/profit-loss",
  PROFITLOSSACCOUNTWISEREPORT: "invoicereports/profit-loss-accountwise",

  GETTEMPLATEBYDOMAIN: "template/by-domain",
  SERIESFARESEARCH: "series-fares/agent-search",

   UPDATELEAD: "lead",
    GETMARKUPBYCOMPANYID: "companymarkup/getallmarkupsbycompany",

  GETCOMPANYPACKAGESBYCOMPANY: "companyPackages/company",
GETALLCOMPANYPACKAGES: 'companyPackages/all',
DELETECOMPANYPACKAGE: "companyPackage",
GETCOMPANYPACKAGEBYID: "companyPackages",
UPDATECOMPANYPACKAGE: "companyPackages",
};
